<template>
  <div class="about-dialog" style="position:absolute; left: 0.6rem; top: 2.33rem; height: 1.667rem; width:8.33rem; z-index: 2001;
  display: flex; flex-direction: column; justify-content: center;">
    <!-- <button class="btn btn-success w-100" @click="dialogVideoVisible = true"> -->
    <el-button :class="['about-btn', { show: isHidden }]" id="aboutButton" type="success"  @click="dialogVideoVisible = true"
               style="width: 5.33rem; height: 1rem; font-size: 0.5rem" round>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-book" viewBox="0 0 18 18" style="fill: white; margin-right: 0.267rem; width: 0.6rem; height: 0.6rem;">
        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783"/>
      </svg>
      About
    <!-- </button> -->
  </el-button>
  
    <el-dialog v-model="dialogVideoVisible" title="Introduction to Network" width="70%" @closed="closeVideoDialog" align-center>
      <div>
        <el-scrollbar max-height="26.67rem">

<!--          <video id="dialog_video" src="Intro to ARCH.mp4" controls="controls" style="width: 60%; margin-top: 16px"></video>-->

          <div style="width:100%; display: flex; flex-direction: column; align-items: center;">
            <div v-html="renderedContent" style="width:70%; text-align: left; margin-bottom: 0.533rem; line-height: 1.7; font-size: 0.8rem"></div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import markdownit from 'markdown-it';

const dialogVideoVisible = ref(false);
const renderedContent = ref('');
const md = markdownit();

defineProps({
  isHidden: {
    type: Boolean,
    default: false
  }
})

function closeVideoDialog() {
  pauseVideo();
}

function pauseVideo() {
  const videoInstance = document.getElementById("dialog_video");
  if (videoInstance && !videoInstance.paused) {
    videoInstance.pause();
  }
}

function loadMarkdownFile() {
  axios.get("./About.md")
    .then(res => {
      renderedContent.value = md.render(res.data);
    }).catch(err => {
      console.error('Failed to load Markdown file:', err);
    });
}

onMounted(() => {
  loadMarkdownFile();
});
</script>

<style scoped>

.about-btn {
  /* 隐藏时位移到屏幕外 */
  transform: translateX(-6.67rem);
  transition: transform 0.3s ease;
}

.about-btn.show {
  transform: translateX(0);
}

/* .about-dialog {

  position: absolute; 
  left: 0; 
  width: 250px; 
  top: 10px; 
  height: 50px; 
  z-index: 2000; 
  display: flex; 
  justify-content: center; 
  flex-direction: column; 
  align-items: center; 
  overflow: hidden; 

} */


.tool-img {
  height: 1.2rem;
  width: 1.2rem;
  margin-right: 8px;
  filter: brightness(0) invert(1);
  opacity: 1;
}

</style>
